import styled from 'styled-components';

export const Root = styled.div`
  margin-left: 50px;
  margin-right: 78px;
`

export const Title = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`